import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class Alert extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: props.isOpen
    };
  }
 

  toggle = () => {
    this.setState(prevState => ({
      open: !prevState.open
    }), (state, prev) => {
      if(!this.state.open && this.props.onClose)
         this.props.onClose()
    });
  }

  componentWillReceiveProps(newProps){
    if(this.state.open != newProps.isOpen)
      this.setState({open: newProps.isOpen})
  }

  render() {
    const {open} = this.state;

    return (
      <div>
        <Modal isOpen={open} toggle={this.toggle} className={this.props.className}>
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody>
            {this.props.message}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggle}>Ok</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default Alert;